import '../../js/vendor/polyfills/polyfill-array-from.js';
import '../../js/vendor/polyfills/polyfill-classlist.js';
import '../../js/vendor/polyfills/polyfill-request-animation-frame.js';

import Component from '../../js/core/component.js';
import Collapse from '../../js/utilities/collapse/u-collapse.js';
import keycodes from '../../js/utilities/keycodes/u-keycodes.js';

/**
 * Accordion Class
 */
class Accordion extends Component {

	/**
	 * Default settings for this component
	 * @return {object} Default settings
	 */
	_defaultSettings () {
		return {
			debug: false,
			element: null,
			icons: false,
		};
	}

	/**
	 * Initialize Accordion
	 */
	_init () {
		this._log('_init()');
		this._log(this.settings);

		this.element = this.settings.element;
		this.items = this.element.children;

		this.first = true;

		Array.from(this.items).forEach((item) => {
			item.collapse = new Collapse({
				element: item,
				icons: this.settings.icons,
				expanded: false,
				selectors: {
					header: '> .c-accordion__title',
					content: '> .c-accordion__content'
				},
				tracking: item.querySelector('[data-title-track]') ? item.querySelector('[data-title-track]').dataset.titleTrack : '', // Used for passing tracking event from heading to button
				on: {
					beforeToggle: (collapse) => {
						let clickedItem = collapse.element;
						Array.from(this.items).forEach((item) => {
							if (item !== clickedItem) {
								item.collapse.collapse();
							}
						});
					}
				},
				prepareCssAnimation: true
			});

			// Run if tracking of content is enabled through [data-track-buttons="true"] on accordion item
			if (item.dataset.trackButtons) {
				this.trackButtons = item.querySelectorAll('a, .c-button');
				if(this.trackButtons.length) {
					this.trackButtons.forEach((button) => {
						// Get the items tracking data
						let trackData = item.querySelector('[data-title-track]').dataset.titleTrack;
						// Replace ' with " and make an object of it
						trackData = trackData.replace(/'/g, '"');
						trackData = JSON.parse(trackData);
						// Add button text as eventLabel
						trackData.eventLabel = button.innerHTML;
						// Make a string of the object and replace " with '
						trackData = JSON.stringify(trackData);
						trackData = trackData.replace(/"/g, '\'');
						// Add the tracking to each link and button
						button.dataset.trackClick = trackData;
					});
				}
			}

		});

		this.triggers = Array.from(this.element.querySelectorAll('.c-accordion__title > button'));

		this._keydownEvents();
	}

	_keydownEvents () {

		this.triggers.forEach((trigger) => {
			trigger.addEventListener('keydown', this._keydownEvent.bind(this));
		});
	}

	_keydownEvent (event) {
		var target = event.target;
		var key = event.which;

		switch (key) {
			case keycodes.UP:
			case keycodes.DOWN:
				var index = this.triggers.indexOf(target);
				var newIndex = index;
				newIndex += (keycodes.DOWN === key) ? 1 : -1;

				this.setFocus(newIndex);
				event.preventDefault();
				break;
			case keycodes.HOME:
				this.focusFirstHeading();
				event.preventDefault();
				break;
			case keycodes.END:
				this.focusLastHeading();
				event.preventDefault();
				break;
		}
	}

	setFocus (index) {
		if (index < 0) {
			this.focusLastHeading();
		}
		else if (index >= this.triggers.length) {
			this.focusFirstHeading();
		}
		else {
			this.triggers[index].focus();
		}
	}

	focusFirstHeading () {
		this.triggers[0].focus();
	}

	focusLastHeading () {
		this.triggers[this.triggers.length - 1].focus();
	}
}
document.addEventListener('newcontent', (e) => {
	e.target.querySelectorAll('.c-accordion').forEach((accordion) => {
		accordion.accordion = new Accordion({
			debug: false,
			element: accordion,
			icons: '/gui/images/icons/plus.svg'
		});
	});
});

export default Accordion;


// WEBPACK FOOTER //
// ./components/accordion/c-accordion.js